import instance from "./auth";

export const getAllData = async (params) => {
    const {data} = await instance.get("/registrations/all", {
        params,
    });
    return data;
}

export const getAll = async (params) => {
    const {data} = await instance.get("/registrations", {
        params,
    });
    return data;
}

export const updateById = async (id, data) => {
    const {data: result} = await instance.put(`/registrations/${id}`, data);
    return result;
}

export const deleteById = async (id) => {
  const { data: result } = await instance.post(`/registrations/${id}`);
  return result;
};
